import { PDPPageReviewSection } from './PDPPageReviewSection';
import GGUCampaignSection from './GGUCampaignSection';
import CountryChangeShortcode from './CountryChangeShortcode';
import { RegisteredDeliveryTracking } from './DeliveryTracking';
import DeliveryTrackingBanner from './DeliveryTrackingBanner';
import { ReviewSection, LoyaltyBannerContainer as LoyaltyBanner, ProfileButton } from '@skin-seoul/shared-components';
import { HeaderCartButton, MobileNavCartButton } from './CartDrawerButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentRegistry = new Map<string, React.ComponentType<any>>([
  ['HomePageReviewSection', ReviewSection],
  ['PDPPageReviewSection', PDPPageReviewSection],
  ['GGUSection', GGUCampaignSection],
  ['CountryChangeShortcode', CountryChangeShortcode],
  ['HeaderCartButton', HeaderCartButton],
  ['MobileNavCartButton', MobileNavCartButton],
  ['LoyaltyBanner', LoyaltyBanner],
  ['ProfileButton', ProfileButton],
  ['RegisteredDeliveryTracking', RegisteredDeliveryTracking],
  ['DeliveryTrackingBanner', DeliveryTrackingBanner],
]);
